import { t } from 'ember-intl';
import QuestionsLoanTypesCard from 'tio-employee/components/questions/loan-types-card';
import { VStack } from 'tio-ui/components/layout';
import {
  PhPercent,
  PhPause,
  PhCurrencyDollar,
  PhChartBar,
  PhWarning,
  PhCaretDoubleRight,
} from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';

interface CircleSignature {
  Args: {
    label: string;
  };
}

const Circle: TOC<CircleSignature> = <template>
  <div
    class="shrink-0 w-6 h-6 bg-cyan-600 mr-2 text-white rounded-full text-center items-center inline-block"
  >
    {{@label}}
  </div>
</template>;

<template>
  <VStack class="px-4">
    <h3 class="text-center font-semibold mt-4">
      {{t "questions_you_have.types_of_student_loans.pros.pros_plus"}}
    </h3>
    <div class="flex flex-col md:flex-row flex-wrap">
      <QuestionsLoanTypesCard
        @icon={{PhPercent}}
        @label={{t "questions_you_have.types_of_student_loans.pros.generally_lower_interest"}}
        class="w-full md:w-1/3 md:border-r"
      />
      <QuestionsLoanTypesCard
        @icon={{PhPause}}
        @label={{t
          "questions_you_have.types_of_student_loans.pros.repayment_options_more_favorable_than"
        }}
        class="w-full md:w-1/3 md:border-r"
      />
      <QuestionsLoanTypesCard
        @icon={{PhCurrencyDollar}}
        @label={{t "questions_you_have.types_of_student_loans.pros.qualify_for_loan_forgiveness"}}
        class="w-full md:w-1/3"
      />
    </div>

    <h3 class="text-center font-semibold mt-4">
      {{t "questions_you_have.types_of_student_loans.cons.cons_plus"}}
    </h3>
    <div class="flex flex-col md:flex-row flex-wrap">
      <QuestionsLoanTypesCard
        @icon={{PhChartBar}}
        @label={{t "questions_you_have.types_of_student_loans.cons.plus_con1"}}
        class="w-full md:w-1/3 md:border-r"
      />
      <QuestionsLoanTypesCard
        @icon={{PhWarning}}
        @label={{t "questions_you_have.types_of_student_loans.cons.plus_con2"}}
        class="w-full md:w-1/3 md:border-r"
      />
      <QuestionsLoanTypesCard
        @icon={{PhCaretDoubleRight}}
        @label={{t "questions_you_have.types_of_student_loans.cons.plus_con3"}}
        class="w-full md:w-1/3"
      />
    </div>
  </VStack>

  <div class="p-4">
    <h2 class="py-4 font-medium text-xl">
      {{t "questions_you_have.how_to_apply.default"}}
    </h2>
    <div class="py-4">
      <h3 class="font-semibold truncate text-left">
        <Circle @label={{t "number_one"}} />
        {{t "questions_you_have.how_to_apply.pplus_ask_yourself.default" htmlSafe=true}}
      </h3>
      <ul class="list-disc ml-12 mb-4">
        <li class="m-4">
          {{t "questions_you_have.how_to_apply.pplus_ask_yourself.point_1"}}
        </li>
        <li class="m-4">
          {{t "questions_you_have.how_to_apply.pplus_ask_yourself.point_2"}}
        </li>
        <li class="m-4">
          {{t "questions_you_have.how_to_apply.pplus_ask_yourself.point_3"}}
        </li>
        <li class="m-4">
          {{t "questions_you_have.how_to_apply.pplus_ask_yourself.point_4"}}
        </li>
        <li class="m-4">
          {{t "questions_you_have.how_to_apply.pplus_ask_yourself.point_5"}}
        </li>
      </ul>
    </div>
    <div class="py-4">
      <h3 class="font-semibold truncate text-left">
        <Circle @label={{t "number_two"}} />
        {{t "questions_you_have.how_to_apply.call_fa_office.default" htmlSafe=true}}
      </h3>
      <ul class="list-disc ml-12 mb-4">
        <li class="m-4">
          {{t "questions_you_have.how_to_apply.pplus_ask_yourself.point_1"}}
        </li>
      </ul>
    </div>
  </div>
</template>
